
import { Component, OnInit, OnChanges, Input, Output, EventEmitter, } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { PickcaseService } from '../../../service/pickcase/pickcase.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9219',
  templateUrl: 'wa9219.component.html',
  styleUrls: ['wa9219.component.scss']
})
export class Wa9219Component implements OnInit {
  public componentTitle = 'WA9219:ピック箱マスタ修正';

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // for error message
  public validation = validation;
  // Define each input element (initial value and validation rule)
  public ownerId: number;
  public ownerCd: string;
  public ownerTx: string;
  public pickcaseId: number;
  public pickcaseCd: string;
  public pickcaseTx: FormControl;
  public volumeNr: FormControl;
  public capacityrateNr: FormControl;
  public updcounterNr: number;
  public selectedOwnerId; // build FormGroup

  private pickcase:any = null;

  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private isSubmitButtonEnabled = false;

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';

  private ownerIdCls = '';
  private pickcaseCdCls = '';
  private pickcaseTxCls = '';
  private volumeNrCls = '';
  private capacityrateNrCls = ''

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private pickcaseService: PickcaseService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {

    this.pickcaseTx = new FormControl('', [
      Validators.required,
      Validators.pattern(validation.allBlankOnly),
      Validators.maxLength(validation.pickcaseTx.maxLength)]);
    this.volumeNr = new FormControl(0, [
      Validators.required,
      Validators.pattern(validation.decimal_3),
      Validators.max(validation.pickcaseVolumeNr.maxNr),
      Validators.min(validation.pickcaseVolumeNr.minNr)]);
    this.capacityrateNr = new FormControl(100, [
      Validators.required,
      Validators.pattern(validation.integer),
      Validators.max(validation.pickcaseCapacityRateNr.maxNr),
      Validators.min(validation.pickcaseCapacityRateNr.minNr)]);

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() { }

  onSubmit() {
    this.errorInfo = '';
    if (!this.isSubmitButtonEnabled)
      return;

    let pickcaseTx = this.pickcaseTx.value.trim();
    let capacityrateNr = this.capacityrateNr.value / 100;
    
    let errors = false;
    if (this.pickcaseTx.errors !== null) {
      this.pickcaseTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.volumeNr.errors !== null) {
      this.volumeNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.capacityrateNr.errors !== null) {
      this.capacityrateNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.pickcaseService
      .put(
        this.pickcaseId,
        this.ownerId,
        this.pickcaseCd,
        pickcaseTx, 
        this.volumeNr.value,
        capacityrateNr,
        'wa9219',
        this.updcounterNr,
        )
      .then(outputJson => {
        if (outputJson.count === 1) {
          sessionStorage.setItem('SuccessInfoMessage', '修正が完了しました');
        }
        this.working = false;
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.errorInfo = '';
    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    const selectedPickcase: object = JSON.parse(sessionStorage.getItem('rowCase'));
    this.pickcase = selectedPickcase;

    this.pickcaseId = selectedPickcase['pickcaseId'];
    this.ownerId =selectedPickcase['ownerId'];
    this.ownerCd = selectedPickcase['ownerCd'];
    this.ownerTx = selectedPickcase['ownerTx'];
    this.pickcaseCd = selectedPickcase['pickcaseCd'];
    this.pickcaseTx.setValue(selectedPickcase['pickcaseTx']);
    this.volumeNr.setValue(selectedPickcase['volumeNr']);
    this.capacityrateNr.setValue(selectedPickcase['capacityrateNr']);
    this.updcounterNr = selectedPickcase['updcounterNr'];

    this.isSubmitButtonEnabled = false;
  }

  ngDoCheck() {
    if (!this.isShow)
      return;

    this.pickcaseTxCls = this.pickcaseTx.value === this.pickcase['pickcaseTx'] ? '' : (this.pickcaseTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.volumeNrCls = this.volumeNr.value === this.pickcase['volumeNr'] ? '' : (this.volumeNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.capacityrateNrCls = this.capacityrateNr.value === this.pickcase['capacityrateNr'] ? '' : (this.capacityrateNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);

    this.checkSubmitButtonState();
  }

  checkSubmitButtonState() {
    if (
      this.pickcaseTxCls !== this.STRINGS_ERROR &&
      this.volumeNrCls !== this.STRINGS_ERROR &&
      this.capacityrateNrCls !== this.STRINGS_ERROR
    ) {
      this.isSubmitButtonEnabled =
        this.pickcaseTxCls === this.STRINGS_ACTIVE ||
        this.volumeNrCls === this.STRINGS_ACTIVE ||
        this.capacityrateNrCls === this.STRINGS_ACTIVE
    } else {
      this.isSubmitButtonEnabled = false;
    }
  }

  clrErr() {
    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9219/wa9219.component.ts